// src/pages/TermsOfService.js
import React from "react";
import Seo from "../components/Seo";
import "./TermsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <Seo
        title="Terms of Service | Clean Sweeps"
        description="Clean Sweeps Terms of Service for the Shopify sweepstakes app."
        path="/tos"
        image="/og/terms.png"
        imageAlt="Clean Sweeps Terms of Service"
      />
      <h1>Terms of Service</h1>

      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to the Clean Sweeps app provided by Clean Sweeps LLC
          (hereinafter "We", "Us", "Our" or "Company"). We thank You (any
          user of our app and hereinafter "You" or "Your") for installing and
          using our app and considering our products and services. By installing
          the Clean Sweeps: buy-to-enter Shopify app, using our app or services,
          or accessing our app, You hereby agree to the terms and conditions of
          this Terms of Use (hereinafter "Agreement"). This Agreement, along
          with the mutual promises You and We make to each other, becomes a
          binding contract between You and Us. Please do not use this app if You
          disagree with any part of this Agreement.
        </p>
        <p>
          Our Mobile Terms of Service is located here and is hereby incorporated
          into this Agreement by reference. Please review the Terms of Service
          to understand Our policies.
        </p>
      </section>

      <section>
        <h2>Copyright</h2>
        <p>
          All content included in the Clean Sweeps app, such as text, graphics,
          logos, button icons, images, audio clips, and software, is the property
          of Clean Sweeps LLC and is protected by U.S. copyright laws. The
          compilation (i.e., the collection, arrangement, and assembly) of all
          content in the app is Our exclusive property and is likewise protected.
          Any use of such content, including the reproduction, modification,
          distribution, transmission, republication, or display, is strictly
          prohibited.
        </p>
      </section>

      <section>
        <h2>Warranties</h2>
        <p>
          THE MATERIAL DISPLAYED IN THE CLEAN SWEEPS APP IS PROVIDED WITHOUT ANY
          GUARANTEES, CONDITIONS, OR WARRANTIES AS TO ITS ACCURACY. UNLESS
          EXPRESSLY STATED TO THE CONTRARY TO THE FULLEST EXTENT PERMITTED BY
          LAW, WE, OUR SUPPLIERS, CONTENT PROVIDERS, AND ADVERTISERS HEREBY
          EXPRESSLY EXCLUDE ALL CONDITIONS, WARRANTIES, AND OTHER TERMS WHICH
          MIGHT OTHERWISE BE IMPLIED BY STATUTE, COMMON LAW, OR THE LAW OF
          EQUITY. WE SHALL NOT BE LIABLE FOR ANY DAMAGES WHATSOEVER, INCLUDING
          BUT NOT LIMITED TO ANY DIRECT, INDIRECT, SPECIAL, CONSEQUENTIAL,
          PUNITIVE OR INCIDENTAL DAMAGES, OR DAMAGES FOR LOSS OF USE, PROFITS,
          DATA, GOODWILL, OR OTHER INTANGIBLES, OR THE COST OF PROCUREMENT OF
          SUBSTITUTE GOODS AND SERVICES, ARISING OUT OF OR RELATED TO YOUR USE,
          INABILITY TO USE, PERFORMANCE OR FAILURE OF THE APP OR ANY MATERIALS
          CONTAINED THEREIN, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF
          SUCH DAMAGES.
        </p>
        <p>
          FURTHERMORE, IF A THIRD PARTY SHALL SURREPTITIOUSLY ENTER THE APP
          THROUGH THE USE OF A USER'S LOG-IN OR OTHERWISE, THEY WILL HAVE NO
          RIGHT OF STANDING IN ANY ACTION AGAINST US.
        </p>
      </section>

      <section>
        <h2>Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT LEGALLY PERMITTED, WHETHER OR NOT WE ARE OR WERE
          AWARE OR ADVISED OF THE POSSIBILITY OF DAMAGES, AND WHETHER OR NOT THE
          LIMITED REMEDIES PROVIDED HEREIN FAIL OF THEIR ESSENTIAL PURPOSE, OUR
          AGGREGATE LIABILITY (WHETHER FOR BREACH OF CONTRACT, TORT, OR ANY OTHER
          LEGAL THEORY) SHALL IN NO CIRCUMSTANCES EXCEED THE COST OF ANY
          PRODUCTS OR SERVICES YOU ORDERED. FURTHER, UNDER NO CIRCUMSTANCES
          SHALL WE BE LIABLE FOR SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL
          DAMAGES, LOST PROFITS, LOST REVENUE, OR COST OF COVER.
        </p>
        <p>
          OUR PRODUCTS AND THE APP ARE PROVIDED "AS IS" WITH NO WARRANTY OF ANY
          KIND. EXCEPT AS EXPRESSLY STATED OTHERWISE IN THIS SECTION, WE MAKE NO
          EXPRESS WARRANTIES OR REPRESENTATIONS AND DISCLAIM ALL IMPLIED
          WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT.
        </p>
        <p>
          FURTHERMORE, IF A THIRD PARTY SHALL SURREPTITIOUSLY ENTER THE APP
          THROUGH THE USE OF A USER'S LOG-IN OR OTHERWISE, THEY WILL HAVE NO
          RIGHT OF STANDING IN ANY ACTION AGAINST US.
        </p>
      </section>

      <section>
        <h2>Indemnification</h2>
        <p>
          You hereby warrant that you will not use any information provided by
          us in violation of any International, Local, State, or Federal law.
          Further, you agree to indemnify, defend, and hold us harmless,
          including our parents, subsidiaries, affiliates, officers, directors,
          employees, agents, and suppliers, from any claim, action, demand, or
          damage -- including reasonable attorney's fees -- arising out of or related
          to your use of any service offered by us or your violation of this
          Agreement. This includes, without limitation, claims for libel,
          violation of rights of privacy or publicity, interference with
          property rights, trespass, or any other violation of applicable law.
        </p>
      </section>

      <section>
        <h2>Force Majeure</h2>
        <p>
          We shall not be liable for delays or nonperformance of this Agreement
          caused by events beyond our reasonable control, including but not
          limited to strikes, fires, accidents, acts of God, war, terrorism,
          riots, embargoes, or other similar events.
        </p>
      </section>

      <section>
        <h2>Assignment</h2>
        <p>
          You may not assign or transfer any rights or obligations under this
          Agreement without our prior written consent. Any unauthorized
          assignment shall be null and void.
        </p>
      </section>

      <section>
        <h2>Entire Agreement</h2>
        <p>
          Except as modified or supplemented by a writing executed by both
          parties, these Terms constitute the entire agreement between you and
          Clean Sweeps LLC with respect to the Clean Sweeps app, and supersede
          all prior agreements, representations, and understandings.
        </p>
      </section>

      <section>
        <h2>Disputes</h2>
        <p>
          In the event of any dispute with us, you agree to attempt to resolve
          the matter by contacting us at{" "}
          <a href="mailto:info@cleansweeps.app">info@cleansweeps.app</a> and
          engaging in a resolution discussion before taking any legal action.
          Failure to attempt such resolution will be deemed a breach of this
          Agreement. This Agreement and your use of the app are governed by the
          laws of the State of Arizona, and any disputes shall be exclusively
          resolved in the state or federal courts located in Maricopa County,
          Arizona. You hereby waive any right to a trial by jury.
        </p>
        <p>
          In addition, in the event of any breach or violation of these Terms,
          we shall be entitled to pursue all available legal remedies, including
          seeking actual damages, statutory damages, treble damages, and
          attorneys' fees.
        </p>
      </section>

      <section>
        <h2>Severability</h2>
        <p>
          If any provision of this Agreement is held by a court of competent
          jurisdiction to be invalid or unenforceable, the remaining provisions
          shall remain in full force and effect. In such case, the invalid
          provision will be substituted with a valid provision that most closely
          approximates the intent and economic effect of the original.
        </p>
      </section>

      <section>
        <h2>Headings</h2>
        <p>
          Section headings in this Agreement are for convenience only and shall
          not affect the interpretation of any provision herein.
        </p>
      </section>

      <section>
        <h2>Privacy Policy</h2>
        <p>
          Our Privacy Policy, available at{" "}
          <a href="/app/privacy-policy">cleansweeps.app/privacy-policy</a>, is
          hereby incorporated into this Agreement by reference and forms part of
          this Agreement. Please review the Privacy Policy to understand how We
          collect, use, disclose, and otherwise process information.
        </p>

        <h3>Data Collection, Use, Sharing, and Sale</h3>
        <p>
          By installing, accessing, or using the Service, You authorize and
          consent to Our collection, storage, use, transmission, disclosure, and
          other processing of information (including Personal Data) as described
          in the Privacy Policy. "Personal Data" may include (without
          limitation) names, email addresses, phone numbers, customer lists,
          order and transaction information, usage data, device identifiers, and
          other information associated with merchants, their customers, or
          participants whose data is made available to Us through the Service.
        </p>
        <p>
          To the maximum extent permitted by applicable law, You authorize Us to
          use such information for Our business purposes, which may include:
          operating and improving the Service; analytics; security and fraud
          prevention; communications; marketing and promotional activities;
          developing new products and services; and sharing or disclosing
          information to Our service providers, partners, affiliates, or other
          third parties. Where permitted by law, these purposes may include the
          <strong> sharing or sale of Personal Data</strong> for commercial and
          marketing purposes.
        </p>
        <p>
          Certain jurisdictions provide individuals with specific rights
          regarding their Personal Data (including rights to opt out of "sale"
          or "sharing" of Personal Data, or to withdraw consent). We will honor
          such rights where required by law, as further described in the Privacy
          Policy. If You do not agree to these data practices, You must
          discontinue use of the Service.
        </p>
      </section>

      <section>
        <h2>Agreement Updates</h2>
        <p>
          This Agreement is effective as of October 1, 2024. We reserve the
          right, at our sole discretion, to modify or update these Terms at any
          time without prior notice. In the event of material changes, we will
          notify you via email or through an in-app notice. Your continued use of
          the Clean Sweeps app after such changes constitutes your acceptance of
          the updated Terms.
        </p>
      </section>

      <section>
        <h2>Use of Service</h2>
        <p>
          Our Service enables users to track and record sweepstakes data. You are
          solely responsible for ensuring that your use of the Service complies
          with all applicable laws and regulations.
        </p>
      </section>

      <section>
        <h2>User Responsibilities</h2>
        <p>
          You agree to use the Service only for lawful purposes and in
          accordance with these Terms. You are solely responsible for any
          sweepstakes or promotional activities you conduct using our Service,
          including ensuring the authenticity and legality of such activities.
        </p>
      </section>

      <section>
        <h2>Prohibited Activities</h2>
        <p>You agree not to engage in any of the following prohibited activities:</p>
        <ul>
          <li>Using the Service for any unlawful purposes.</li>
          <li>Attempting to gain unauthorized access to the Service.</li>
          <li>Interfering with the proper functioning of the Service.</li>
          <li>Distributing malware or other harmful software.</li>
        </ul>
      </section>

      <section>
        <h2>Ownership and Intellectual Property</h2>
        <p>
          All content, features, and functionality of the Service are and will
          remain the exclusive property of Clean Sweeps LLC and its licensors.
          The Service is protected by copyright, trademark, and other applicable
          laws.
        </p>
      </section>

      <section>
        <h2>Disclaimer of Warranties</h2>
        <p>
          The Service is provided on an "AS IS" and "AS AVAILABLE" basis. Clean
          Sweeps LLC makes no representations or warranties of any kind, express
          or implied, regarding the operation or availability of the Service, or
          the information, content, or materials included therein.
        </p>
      </section>

      <section>
        <h2>Limitation of Liability</h2>
        <p>
          In no event shall Clean Sweeps LLC, nor its directors, employees,
          partners, agents, suppliers, or affiliates, be liable for any
          indirect, incidental, special, consequential or punitive damages,
          including without limitation, loss of profits, data, use, goodwill, or
          other intangible losses, arising from:
        </p>
        <ul>
          <li>
            Your access to or use of or inability to access or use the Service;
          </li>
          <li>Any conduct or content of any third party on the Service;</li>
          <li>Any content obtained from the Service; or</li>
          <li>
            Unauthorized access, use, or alteration of your transmissions or
            content.
          </li>
        </ul>
      </section>

      <section>
        <h2>Indemnification (for Service Use)</h2>
        <p>
          You agree to defend, indemnify and hold harmless Clean Sweeps LLC and
          its licensees, licensors, and their employees, contractors, agents,
          officers, and directors from and against any and all claims, damages,
          obligations, losses, liabilities, costs or debts, and expenses
          (including reasonable attorney's fees) arising from:
        </p>
        <ul>
          <li>
            Your use and access of the Service, whether by you or any person
            using your account and password;
          </li>
          <li>A breach of these Terms; or</li>
          <li>Any content posted on the Service.</li>
        </ul>
      </section>

      <section>
        <h2>Termination</h2>
        <p>
          We may terminate or suspend your account and bar access to the Service
          immediately, without prior notice or liability, at our sole
          discretion, for any reason whatsoever, including but not limited to a
          breach of these Terms. All provisions of these Terms which by their
          nature should survive termination shall survive termination.
        </p>
      </section>

      <section>
        <h2>Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of the State of Arizona, without regard to its conflict of law
          provisions.
        </p>
      </section>

      <section>
        <h2>Changes to Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is material, we will provide at
          least 30 days' notice prior to any new terms taking effect. By
          continuing to access or use the Service after such revisions become
          effective, you agree to be bound by the updated Terms. If you do not
          agree to the new terms, you are no longer authorized to use the
          Service.
        </p>
      </section>

      <section>
        <h2>Disclaimer of Liability for Sweepstakes Management</h2>
        <p>
          Clean Sweeps LLC provides the Clean Sweeps app solely as a record
          holder, ledger, and source of truth for managing sweepstakes entries.
          We do not own, operate, sponsor, or assume any liability for
          sweepstakes conducted through our Service. Your use of the Service to
          manage sweepstakes is entirely at your own risk.
        </p>
      </section>

      <section>
        <h3>Limitation of Role</h3>
        <p>
          Our role is strictly limited to providing the technological
          infrastructure for managing sweepstakes entries. We do not:
        </p>
        <ul>
          <li>Design, execute, or administer sweepstakes;</li>
          <li>Make decisions regarding the rules, eligibility, or execution of sweepstakes;</li>
          <li>Handle prize fulfillment or manage related obligations; or</li>
          <li>Ensure compliance with sweepstakes laws and regulations.</li>
        </ul>
      </section>

      <section>
        <h3>Merchant Responsibilities</h3>
        <p>
          Merchants utilizing our Service bear full responsibility for the
          creation, execution, and management of their sweepstakes. Specifically,
          merchants are solely responsible for:
        </p>
        <ol>
          <li>
            <strong>Designing and Executing Sweepstakes:</strong>
            <ul>
              <li>
                Developing sweepstakes rules, eligibility criteria, entry
                methods, and prize structures.
              </li>
            </ul>
          </li>
          <li>
            <strong>Legal Compliance:</strong>
            <ul>
              <li>
                Ensuring that all sweepstakes comply with applicable local,
                state, and federal laws and regulations.
              </li>
              <li>
                Securing any necessary permits, licenses, or approvals required
                to conduct sweepstakes.
              </li>
            </ul>
          </li>
          <li>
            <strong>Prize Fulfillment:</strong>
            <ul>
              <li>
                Managing the distribution and fulfillment of prizes, including
                handling any associated costs or logistics.
              </li>
            </ul>
          </li>
          <li>
            <strong>Promotional Integrity:</strong>
            <ul>
              <li>
                Maintaining accurate, truthful, and non-deceptive information in
                all sweepstakes promotions.
              </li>
              <li>
                Avoiding misleading advertising or false claims related to the
                sweepstakes.
              </li>
            </ul>
          </li>
          <li>
            <strong>Data Protection:</strong>
            <ul>
              <li>
                Protecting the personal information of participants in
                accordance with relevant data protection laws and regulations.
              </li>
            </ul>
          </li>
        </ol>
      </section>

      <section>
        <h3>No Liability for Sweepstakes Conduct</h3>
        <p>Clean Sweeps LLC is not liable for:</p>
        <ul>
          <li>
            Any actions, omissions, or misconduct of merchants in conducting
            sweepstakes.
          </li>
          <li>
            The legality, fairness, or integrity of any sweepstakes managed
            through our Service.
          </li>
          <li>
            Any disputes, claims, or legal actions arising from sweepstakes
            conducted by merchants.
          </li>
          <li>
            Any direct, indirect, incidental, consequential, or punitive damages
            resulting from the use or inability to use the Service in relation
            to sweepstakes management.
          </li>
        </ul>
        <p>
          Furthermore, Clean Sweeps LLC is not liable for any misuse of the
          Service by merchants or any third parties. Merchants agree to
          indemnify, defend, and hold Clean Sweeps LLC harmless from any claims
          arising from their misuse of the Service.
        </p>
      </section>

      <section>
        <h2>Additional Disclaimers</h2>
        <p>In addition to the foregoing, you acknowledge and agree that:</p>
        <ul>
          <li>
            The Clean Sweeps app may experience occasional technical
            interruptions, errors, or downtime.
          </li>
          <li>
            We are not responsible for data loss, corruption, or inaccuracies
            due to technical failures or unauthorized access.
          </li>
          <li>
            Failure by us to enforce any provision of these Terms shall not be
            deemed a waiver of our right to enforce such provision in the
            future.
          </li>
          <li>
            Third-party integrations or links provided within the app are
            offered solely for your convenience and do not imply any endorsement
            or responsibility by Clean Sweeps LLC.
          </li>
        </ul>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at:</p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:info@cleansweeps.app">info@cleansweeps.app</a>
        </p>
        <p>
          If you do not agree to these Terms, please uninstall or do not use the
          Clean Sweeps app.
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
